import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FarbweltLogo } from "@/components";
import { useHardFacts } from "@/contexts/classified";
import { formatTextWithHtml } from "@/utils";
import { Box } from "@gemini/core";
import { useFacts } from "@/components/Sections/Hardfacts";
export const projectBannerInfoTestId = "cdp-open-form-sticky-project-banner-info";
export const ProjectBannerInfo = () => {
    // @ts-ignore
    const { title } = useHardFacts();
    const facts = useFacts() || [];
    const formattedFacts = facts
        .map((fact) => fact.value)
        .join("&nbsp;&nbsp;•&nbsp;&nbsp;")
        .replace(/<br\s*\/?>/g, " ");
    return (_jsxs(Box, { display: "flex", gap: "spacing.16", marginLeft: {
            "breakpoint.lg": "spacing.32",
            "breakpoint.xl": "spacing.80",
        }, marginRight: "auto", testId: projectBannerInfoTestId, children: [_jsx(FarbweltLogo, { position: "inherit", testId: `${projectBannerInfoTestId}.Logo` }), _jsxs(Box, { display: "flex", flexDirection: "column", justifyContent: "center", children: [_jsx(Box, { typography: "typography.headline.24.bold", children: title }), _jsx(Box, { typography: "typography.body.14.regular", dangerouslySetInnerHTML: {
                            __html: formatTextWithHtml(formattedFacts),
                        } })] })] }));
};
